import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Minh chứng", -1)

import Divider from "primevue/divider";
import ViewImage from "./ViewImage.vue";
import CommonDetail from './CommonDetail.vue';
const width = 320;

export default /*#__PURE__*/_defineComponent({
  __name: 'ThongTinXetTuyen',
  props: {
    registration: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDetail, { registration: _ctx.registration }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Divider), {
          align: "center",
          type: "solid"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      (_ctx.registration?.anhHocBaTrangDau.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 0,
            images: _ctx.registration?.anhHocBaTrangDau,
            title: "Ảnh trang đầu học bạ (trang có dán ảnh)",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhHocBaLop10.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 1,
            images: _ctx.registration?.anhHocBaLop10,
            title: "Ảnh trang kết quả các môn học lớp 10",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhHocBaLop11.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 2,
            images: _ctx.registration?.anhHocBaLop11,
            title: "Ảnh trang kết quả các môn học lớp 11",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhHocBaLop12.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 3,
            images: _ctx.registration?.anhHocBaLop12,
            title: "Ảnh trang kết quả các môn học lớp 12",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhCanCuocCongDanMatTruoc.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 4,
            images: _ctx.registration?.anhCanCuocCongDanMatTruoc,
            title: "Ảnh mặt trước Căn cước Công dân",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhCanCuocCongDanMatSau.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 5,
            images: _ctx.registration?.anhCanCuocCongDanMatSau,
            title: "Ảnh mặt sau Căn cước Công dân",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhChungChiIelts.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 6,
            images: _ctx.registration?.anhChungChiIelts,
            title: "Ảnh chứng chỉ Ielts",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhDoiTuongUuTien.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 7,
            images: _ctx.registration?.anhDoiTuongUuTien,
            title: "Ảnh minh chứng đối tượng ưu tiên",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhKhuVucUuTien.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 8,
            images: _ctx.registration?.anhKhuVucUuTien,
            title: "Minh chứng khu vực ưu tiên KV1 (Ảnh hộ khẩu)",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhDatGiai.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 9,
            images: _ctx.registration?.anhDatGiai,
            title: "Ảnh minh chứng đoạt giải nhất, nhì, ba trong kỳ thi học sinh giỏi cấp Tỉnh/Thành phố",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true),
      (_ctx.registration?.anhDiemNangKhieu.length)
        ? (_openBlock(), _createBlock(ViewImage, {
            key: 10,
            images: _ctx.registration?.anhDiemNangKhieu,
            title: "Ảnh Điểm năng khiếu môn Vẽ mỹ thuật",
            width: width,
            preview: ""
          }, null, 8, ["images"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["registration"]))
}
}

})